<section>
  <!-- <form> -->
    <div class="row" style="margin-top: 15px">
      <div class="col-lg-12">
        <h5 class="text-center">Previsão de Atendimento</h5>
        <div class="text-center">
          <button
          type="button"
          (click)="newItem()"
          class="btn btn-primary margin"
          style="margin-left: 5px;"
          >
            <mat-icon
              aria-hidden="true"

              aria-label="Example home icon"
            >
              add
            </mat-icon>

          </button>
        </div>
        <div class="row" style="margin: 10px;">
          <mat-card
            *ngFor="let item of items; let i = index"
            style="margin: 5px"
          >
            <mat-card-content>
              <input
                type="date"
                class="form-control"
                [(ngModel)]="item.date"
                name="date"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="send()"
              />
              <textarea
                type="text"
                class="form-control"
                [(ngModel)]="item.observation"
                name="text"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="send()"
                placeholder="Serviços/Obs..."
              ></textarea>
            </mat-card-content>
            <mat-card-actions align="start">
              <a href="javascript:void(0)" (click)="destroy(item)">
                <mat-icon
                  aria-hidden="true"
                  style="color: #d9534f"
                  aria-label="Example home icon"
                >
                  delete
                </mat-icon>
              </a>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </div>
  <!-- </form> -->
</section>
